import React from 'react';
import { TextInput, required, FormDataConsumer, useTranslate } from 'react-admin';
import { HiddenInput } from '~/components/ra';

interface Props {
  edit?: boolean;
  record?: any;
}

const l = (key: string): string => `resources.menu.fields.${key}`;

const MenuForm = (props: Props) => {
  const { edit } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  const validateCode = (value: string): string | undefined => {
    return /^[A-Z0-9_]*$/.test(value) ? undefined : t('codeValidation');
  };
  return (
    <FormDataConsumer>
      {() => {
        return (
          <>
            {edit && <HiddenInput source='id' />}
            <TextInput source='name' label={t('name')} validate={required()} />
            <TextInput source='code' label={t('code')} validate={[required(), validateCode]} />
          </>
        );
      }}
    </FormDataConsumer>
  );
};

export default MenuForm;
